import React, { Component } from "react"

import ErrorMessageDialog from "../ui/ErrorMessageDialog.js"

import Screen from '../ui/Screen.js'

import ControlPanel from "./DewarsScreen/ControlPanel.js"
import DewarsList from "./DewarsScreen/DewarsList.js"

import CreateDewarDialog from "./DewarsScreen/CreateDewarDialog.js"
import EditDewarDialog from "./DewarsScreen/EditDewarDialog.js"
import DeleteDewarDialog from "./DewarsScreen/DeleteDewarDialog.js"

import api from "../api.js"

class DewarsScreen extends Component {

    constructor(props) {

        super(props)

        this.state = {
            dialog: undefined,
            screen: undefined,
            selected: undefined,
            dewars: [],
        }

        this.handle_error = this.handle_error.bind(this)

        this.handle_DewarsList_onDewarClick = this.handle_DewarsList_onDewarClick.bind(this)
        this.handle_DewarsList_onDewarDoubleClick = this.handle_DewarsList_onDewarDoubleClick.bind(this)

        this.handle_ControlPanel_onAddDewarClick = this.handle_ControlPanel_onAddDewarClick.bind(this)
        this.handle_ControlPanel_onEditDewarClick = this.handle_ControlPanel_onEditDewarClick.bind(this)
        this.handle_ControlPanel_onDeleteDewarClick = this.handle_ControlPanel_onDeleteDewarClick.bind(this)
    
    }

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => {this.setState({dialog: undefined})})
						.catch(this.handle_error)
				}}
			/>
		})
	}    

    async update() {
        let response = await api.dewars.list()
        this.setState({dewars: response.dewars})
    }

	componentDidMount() {
		this.update().catch(this.handleError)
	}

    handle_DewarsList_onDewarClick(dewar) {
        this.setState({selected: dewar})
    }

    handle_DewarsList_onDewarDoubleClick(dewar) {
        this.handle_ControlPanel_onEditDewarClick(dewar)
    }

    handle_ControlPanel_onAddDewarClick() {
		this.setState({
			dialog: <CreateDewarDialog
				onCreateDewarClick = {async (dewar) => {
                    try {
                        await api.dewars.create(dewar.code)
                        await this.update()
                        this.setState({ dialog: undefined, selected: undefined })
                    }
                    catch (e) {
                        this.handle_error(e)
                    }
				}}
				onCancelClick = {() => {
                    this.setState({ dialog: undefined })
                }}
			/>
		})
    }

    handle_ControlPanel_onEditDewarClick(dewar) {
		this.setState({
			dialog: <EditDewarDialog
                dewar = {dewar}
                onEditDewarClick = {async (dewar) => {
                    try {
                        await api.dewars.update_code(dewar.id, dewar.code)
                        await this.update()
                        this.setState({ dialog: undefined, selected: undefined })
                    }
                    catch (e) {
                        this.handle_error(e)
                    }
				}}
				onCancelClick = {() => {
                    this.setState({ dialog: undefined })
                }}
			/>
		})
    }

    handle_ControlPanel_onDeleteDewarClick (dewar) {
		this.setState({
			dialog: <DeleteDewarDialog
				dewar = {dewar}
				onDeleteDewarClick = {async (dewar) => {
                    try {
                        await api.dewars.delete(dewar.id)
                        await this.update()
                        this.setState({dialog: undefined, selected: undefined})
                    }
                    catch (e) {
                        this.handle_error(e)
                    }
				}}
				onCancelClick = {() => {
                    this.setState({dialog: undefined})
                }}
			/>
		})
    }

    render() {

		if (this.state.screen) {
			return this.state.screen
		}

        return <Screen
            onClick = {e => {
                e.stopPropagation()
                if (!this.state.dialog) this.setState({selected: undefined})
            }}
        >
            
            { this.state.dialog }

			<ControlPanel
				selected = {this.state.selected}
				onAddDewarClick = {this.handle_ControlPanel_onAddDewarClick}
				onEditDewarClick = {this.handle_ControlPanel_onEditDewarClick}
				onDeleteDewarClick = {this.handle_ControlPanel_onDeleteDewarClick}
			/>            

            <DewarsList 
                dewars = {this.state.dewars}
                selected = {this.state.selected}
                onDewarClick = {this.handle_DewarsList_onDewarClick}
                onDewarDoubleClick = {this.handle_DewarsList_onDewarDoubleClick}
            />

        </Screen>

    }

}

export default DewarsScreen